import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { adminUserApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

interface AssignProfileVariables {
  userId: string;
  expertProfileId: number | null;
}

export function useAssignProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: AssignProfileVariables) =>
      adminUserApi.assignProfile(variables.userId, variables.expertProfileId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.adminUsers.detail(variables.userId),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.adminUsers.lists() });

      const message = variables.expertProfileId
        ? 'Expert profile assigned successfully'
        : 'Expert profile unassigned successfully';
      toast.success(message);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to assign profile');
    },
  });
}
